import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ImageWrapperStyled = styled(Stack)(({ theme }) => ({
  padding: '32px 38px',
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '16px'
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10',
    width: '600px'
  }
}));
